/**
 * Fetches user orders from GET /api/admin/users/:userId/orders with pagination.
 * No cache (staleTime=0, gcTime=0), refetch on mount.
 */
import { useNoCacheQuery } from './useNoCacheQuery';
import {
  fetchUserOrders,
  type UserOrdersResponse,
} from '../services/userManagementService';

export function useUserOrders(
  userId: string | undefined,
  params: { page?: number; limit?: number; search?: string } = {}
) {
  const { page = 1, limit = 20, search = '' } = params;
  return useNoCacheQuery<
    {
      data: UserOrdersResponse['data'];
      pagination: UserOrdersResponse['pagination'];
    },
    Error
  >({
    queryKey: ['user', userId, 'orders', page, limit, search],
    queryFn: async () => {
      if (!userId) throw new Error('userId required');
      const res = await fetchUserOrders(userId, { page, limit, search });
      if (!res.success) throw new Error('Failed to load orders');
      return { data: res.data, pagination: res.pagination };
    },
    enabled: !!userId,
  });
}
